import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Draggable from 'react-draggable';
import ModalDialog from 'react-bootstrap/ModalDialog';

let modalInstance = null;

function DraggableModalDialog(props) {
    return (
        <Draggable handle='.modal-header'>
            <ModalDialog {...props} />
        </Draggable>
    )
}

function CustomModal() {
    const [show, setShow] = useState(false);
    const [content, setContent] = useState({});
    const [isDraggable, setIsDraggable] = useState(false);
    const [sizeModal, setSizeModal] = useState("lg")
    const [onHideCallback, setOnHideCallback] = useState(null);

    const handleClose = () => {
        setShow(false);
        if (onHideCallback) {
            onHideCallback();
        }
        setContent({});
        setOnHideCallback(null);
    }

    const handleShow = ({ title, footer, body, isDrag = false, size, onHide}) => {
        
        setContent({ title, footer, body });
        setIsDraggable(isDrag);
        setShow(true);
        setOnHideCallback(onHide || null);

        if(size){
            setSizeModal(size)
        }
    }

    const handleUpdate = ({ title, footer, body, isDrag = false, size, onHide }) => {
        setContent({ title, footer, body });
        setIsDraggable(isDrag);
        if (onHide) {
            setOnHideCallback(onHide);
        }
        if(size){
            setSizeModal(size)
        }
    }

    const onStart = () => {
        modalInstance = {
            handleClose,
            handleShow,
            handleUpdate
        }
    }

    useEffect(onStart, [])

    const { title, footer, body } = content;
    return (
        <Modal
            show={show}
            onHide={handleClose}
            size={sizeModal}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogAs={isDraggable ? DraggableModalDialog : ModalDialog}
            enforceFocus={false}
            backdrop="static"
        >
                { title &&
                    <Modal.Header closeButton style={isDraggable ? { cursor: "move" } : {}}>
                        <Modal.Title>{ title }</Modal.Title>
                    </Modal.Header>
                }

                { body &&
                    <Modal.Body>
                        { body }
                    </Modal.Body>
                }

                { footer &&
                    <Modal.Footer>
                        { footer }
                    </Modal.Footer>
                }
        </Modal>
    )
}

CustomModal.show = ({ title, footer, body, isDrag, size, onHide }) => {
    modalInstance.handleShow({ title, footer, body, isDrag, size, onHide });
}

CustomModal.update = ({ title, footer, body, isDrag, size, onHide }) => {
    if (modalInstance && modalInstance.handleUpdate) {
        modalInstance.handleUpdate({ title, footer, body, isDrag, size, onHide });
    }
}

CustomModal.hide = () => {
    modalInstance.handleClose();
}

export default CustomModal;
